// @ts-check
import React, { StatelessComponent } from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import withSideEffect from 'react-side-effect';
import DocumentTitle from 'react-document-title';
import { updateTitle } from 'shared/actions/PageDataActions';
import { connect } from 'react-redux';

const pageTitleize = (title) => (title ? `AristaMD - ${title}` : 'AristaMD');

/**
 * @type { StatelessComponent<{title: string}> }
 */
const PageTitle = ({ title, ...props }) => (
  <DocumentTitle title={pageTitleize(title)} {...props} />
);

PageTitle.displayName = 'PageTitle';

PageTitle.propTypes = {
  title: PropTypes.string.isRequired,
};

function reducePropsToState(propsList) {
  return propsList[propsList.length - 1];
}

function handleStateChangeOnClient(props) {
  if (props) props.dispatch(updateTitle(props.title || ''));
  return null;
}

export default connect()(
  withSideEffect(reducePropsToState, handleStateChangeOnClient)(PageTitle)
);
